import { useState } from 'react'

import { useLightMode } from '@/hooks/useLightMode'

import { Box, IconButton, Tooltip } from '@hivewatch/dark'

import {
  inboxReadToggleIndicatorStyles,
  inboxReadToggleStyles,
} from './InboxReadToggle.styles'

interface InboxReadToggleIProps {
  disabled?: boolean
  isActive: boolean
  onClick: () => void
  tooltipLabel: string
}

export const InboxReadToggle = ({
  disabled = false,
  isActive,
  onClick,
  tooltipLabel,
}: InboxReadToggleIProps) => {
  const colorScheme = useLightMode()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  return (
    <>
      <IconButton
        {...inboxReadToggleStyles(colorScheme, disabled)}
        aria-label={tooltipLabel}
        aria-pressed={isActive}
        colorScheme={colorScheme}
        data-testid='InboxReadToggle'
        dimension={22}
        disabled={disabled}
        icon={
          isActive ? (
            <Box
              {...inboxReadToggleIndicatorStyles(colorScheme)}
              data-testid='InboxReadToggle:indicator'
            />
          ) : null
        }
        onBlur={() => setAnchorEl(null)}
        onClick={onClick}
        onFocus={(event) => setAnchorEl(event.currentTarget)}
        onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
      />
      <Tooltip
        anchorEl={anchorEl}
        colorScheme={colorScheme}
        label={tooltipLabel}
        placement='left'
      />
    </>
  )
}
